import { t as e } from "../utils-DiFe-_ei.js";
import { t } from "../dist-B6xjZgdF.js";
import { t as n } from "../dist-7tgynhKG.js";
import * as r from "react";
import { jsx as i } from "react/jsx-runtime";
//#region src/foundations/button/button.tsx
var a = t("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 cursor-pointer", {
	variants: {
		variant: {
			default: "bg-primary text-primary-foreground hover:bg-primary/90",
			destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
			outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
			secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
			ghost: "hover:bg-accent hover:text-accent-foreground",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-10 px-4 py-2",
			sm: "h-9 px-3",
			lg: "h-11 px-8",
			icon: "h-10 w-10"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), o = r.forwardRef(({ className: t, variant: r, size: o, asChild: s = !1, ...c }, l) => /* @__PURE__ */ i(s ? n : "button", {
	className: e(a({
		variant: r,
		size: o,
		className: t
	})),
	ref: l,
	...c
}));
o.displayName = "Button";
//#endregion
export { o as Button, a as buttonVariants };

//# sourceMappingURL=button.js.map